// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9277b726","355":"627b2c8f","453":"68d21014","859":"d833a674","928":"09a3479f"}[chunkId] + ".chunk.js";
};